
import TermsOfServiceBody from "./TermsOfServiceBody"

export default function TermsOfService() {
  return(
    <>
      <TermsOfServiceBody/>
    </>
  )
}